import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';
import type FlowModel from 'garaje/models/flow';
import type UserModel from 'garaje/models/user';
import type FlashMessagesService from 'garaje/services/flash-messages';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';

interface VisitorDocumentContactsComponentSignature {
  Args: {
    flow: FlowModel;
    onChange: (contacts: UserModel[]) => void;
    searchUsersTask: (query: string) => Promise<UserModel[]>;
    isDisabled?: boolean;
    contacts: UserModel[];
  };
}

export default class VisitorDocumentContactsComponent extends Component<VisitorDocumentContactsComponentSignature> {
  @service declare flashMessages: FlashMessagesService;

  @tracked hasChanged = false;

  @action
  updateContacts(contacts: UserModel[]): void {
    this.hasChanged = true;
    this.args.onChange(contacts);
  }

  saveContactsTask = dropTask(async () => {
    try {
      await this.args.flow.save();
      this.hasChanged = false;
      this.flashMessages.showAndHideFlash('success', 'Contacts saved!');
    } catch (e) {
      this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
    }
  });
}
